"use client";
import { cn, Help } from "utils";
import Spinner from "../Icon/spinner.svg";
import Logout from "../Icon/logout.svg";
import { ElProps } from "@/type";
import { FC, useContext } from "react";
import { GlobalContext } from "@/context";

interface BindWalletProps extends ElProps {
  address: string;
  loading: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
  bindClassName?: string;
}

  export const BindWallet: FC<BindWalletProps> = ({className, bindClassName, address, loading, onConnect, onDisconnect }) => {
  const { loggingIn } = useContext(GlobalContext);
  if (address && !loading && loggingIn) {
    return (
      <button
      disabled={loading}
      className={cn("btn-md text-base font-bold rounded-[36px] btn-border-black",className, bindClassName)}
      onClick={onDisconnect}
    >
      {Help.hideMiddlePart(address || '')}
      <Logout className="fill-Content-Primary w-5 h-5"/>
    </button>
    )
  }
  return (
    <button
      disabled={loading}
      className={cn("px-4 py-2 bg-Content-Inverse-Primary-BG text-Content-Inverse-Primary rounded-[36px] cursor-pointer",className)}
      onClick={onConnect}
    >
      {loading ? (
        <Spinner
          className={cn("fill-Content-Inverse-Primary w-5 h-5 animate-spin")}
        />
      ) : (
        "Connect wallet"
      )}
    </button>
  );
}